// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_f2756da","container":"_c3f01c2","withTitle":"_5e1d815","toInspect":"_14cf0b8"};